
export default {
  computed: {
    icons () {
      return this.$store.state.icons
    },
  },
  // methods: {
  //   iconOrNull (name) {
  //     return this.icons[name] || this.icons.null
  //   },
  // },
}
